module.exports = __webpack_public_path__ + "img/percent-fill.734fc6c4.svg";